import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData ={
    UserPoolId:"us-east-1_z0MtKHK91", 
    ClientId:"57ufts38hn5jtj6hijhe2toir6" 
}

export default new CognitoUserPool(poolData);